export default __webpack_public_path__ + "static/media/introduction-fundamental-icon.45dc9914.svg";